module.exports = __webpack_public_path__ + "img/1492933111.c924ed3a.jpg";